<ws-modal-wrapper headerLabel="Pause Service"
                  (save)="pause()"
                  (cancel)="cancel()"
                  [disableSave]="!form.valid">
    <form [formGroup]="form">
        <div class="row">
            <div class="col-lg-12">
                <div class="mb-3"
                     [ngClass]="{ 'has-error': form.controls.message.touched && form.controls.message.errors }">
                    <label for="message"
                           helpTooltip
                           helpContentId="long-running-process-quiesce-modal.message"
                           position="bottom">
                        Message
                    </label>
                    <input type="text" class="form-control" id="message" formControlName="message" autocomplete="off"/>
                    @if (form.controls.message.touched && form.controls.message.errors) {
                        <div class="error-feedback">
                            @if (form.controls.message.errors.maxlength) {
                                <div class="text-danger small">Message max length is 100 characters.</div>
                            }
                            @if (form.controls.message.errors.required) {
                                <div class="text-danger small">Message is required.</div>
                            }
                        </div>
                    }
                </div>
            </div>
        </div>
    </form>
</ws-modal-wrapper>
